import { useState, useCallback } from 'react';
import { LeaveEntry } from '@techgitter/contracts';
import {
  createLeaveEntry,
  updateLeaveEntry,
  deleteLeaveEntry,
  CreateLeaveDto,
  UpdateLeaveDto,
} from '../../../services/leaveDataService';

export function useLeaveManagement() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createLeave = useCallback(async (data: CreateLeaveDto): Promise<LeaveEntry | null> => {
    setIsSubmitting(true);
    setError(null);
    try {
      const entry = await createLeaveEntry(data);
      return entry;
    } catch (err: any) {
      setError(err.message || 'Failed to create leave entry');
      return null;
    } finally {
      setIsSubmitting(false);
    }
  }, []);

  const updateLeave = useCallback(async (uuid: string, data: UpdateLeaveDto): Promise<boolean> => {
    setIsSubmitting(true);
    setError(null);
    try {
      await updateLeaveEntry(uuid, data);
      return true;
    } catch (err: any) {
      setError(err.message || 'Failed to update leave entry');
      return false;
    } finally {
      setIsSubmitting(false);
    }
  }, []);

  const deleteLeave = useCallback(async (uuid: string): Promise<boolean> => {
    setIsSubmitting(true);
    setError(null);
    try {
      await deleteLeaveEntry(uuid);
      return true;
    } catch (err: any) {
      setError(err.message || 'Failed to delete leave entry');
      return false;
    } finally {
      setIsSubmitting(false);
    }
  }, []);

  return {
    isSubmitting,
    error,
    createLeave,
    updateLeave,
    deleteLeave,
  };
}
